import { render, staticRenderFns } from "./HeadSection.vue?vue&type=template&id=64e438f4&scoped=true&"
import script from "./HeadSection.vue?vue&type=script&lang=ts&"
export * from "./HeadSection.vue?vue&type=script&lang=ts&"
import style0 from "./HeadSection.vue?vue&type=style&index=0&id=64e438f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e438f4",
  null
  
)

export default component.exports